import { AccountType } from '@mews-commander/data-access';
import { CommanderThunkAction, WithCompanyId, WithCustomerId, WithScope } from '@mews-commander/types';
import { createAction, lt, showSuccessAlert } from '@mews/framework';
import { updateAccount, fetchAccountById } from '@mews-commander/legacy-entities/src/actions';
import { getCustomerIdsByCompanyId } from '@mews-commander/legacy-entities/src/ducks';
import { changePaginationIds } from '../../pagination/actions';
import {
    COMPANY_DETAIL_CONTACT_INFO_UPDATE_STARTED,
    COMPANY_DETAIL_CONTACT_INFO_UPDATE_SUCCEEDED,
} from '../actionTypes';
import { createContactsPagination } from './tabs';

const relatedContactListChanged =
    (companyId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getCustomerIdsByCompanyId(getState(), { companyId });
        dispatch(changePaginationIds(ids, scope));
    };

export const addRelatedContact =
    ({ customerId }: WithCustomerId, companyId: string, scope: string): CommanderThunkAction =>
    async (dispatch) => {
        dispatch(createAction(COMPANY_DETAIL_CONTACT_INFO_UPDATE_STARTED));
        const accountUpdates = [
            {
                data: {
                    discriminator: AccountType.Customer,
                    value: {
                        id: customerId,
                        companyId: { value: companyId },
                    },
                },
            },
        ];
        await dispatch(updateAccount({ accountUpdates }));
        dispatch(relatedContactListChanged(companyId, scope));
        showSuccessAlert({ description: lt('SaveSuccessMessage') });
        return dispatch(createAction(COMPANY_DETAIL_CONTACT_INFO_UPDATE_SUCCEEDED));
    };

type CloseRelatedContactModalParams = WithCompanyId & WithScope & { relatedCustomerId: string };

export const closeRelatedContactModal =
    ({ companyId, relatedCustomerId, scope }: CloseRelatedContactModalParams): CommanderThunkAction =>
    async (dispatch) =>
        dispatch(fetchAccountById({ accountId: relatedCustomerId })).then(() =>
            dispatch(createContactsPagination(companyId, scope))
        );
